import type { CampaignStatus, SendMode } from '../model/types';
import { CAMPAIGN_STATUS_META } from '../model/status';
import { DatePicker } from '@/shared/ui/date-picker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
import type { MarketingCampaignFilters } from '../model/campaign-filters';

const STATUS_FILTERS: Array<{ value: MarketingCampaignFilters['status']; label: string }> = [
  { value: 'all', label: 'Todos os estados' },
  ...(Object.keys(CAMPAIGN_STATUS_META) as CampaignStatus[]).map((status) => ({
    value: status,
    label: CAMPAIGN_STATUS_META[status].label,
  })),
];

const SEND_FILTERS: Array<{ value: MarketingCampaignFilters['sendMode']; label: string }> = [
  { value: 'all', label: 'Todos os envios' },
  { value: 'now', label: 'Envio agora' },
  { value: 'later', label: 'Agendado' },
];

export function CampaignFilters({
  value,
  onChange,
}: {
  value: MarketingCampaignFilters;
  onChange: (next: MarketingCampaignFilters) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select value={value.status} onValueChange={(status) => onChange({ ...value, status: status as MarketingCampaignFilters['status'] })}>
        <SelectTrigger aria-label="Filtrar por estado" className="w-full sm:w-auto sm:min-w-[11rem]">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          {STATUS_FILTERS.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={value.sendMode}
        onValueChange={(sendMode) => onChange({ ...value, sendMode: sendMode as SendMode | 'all' })}
      >
        <SelectTrigger aria-label="Filtrar por envio" className="w-full sm:w-auto sm:min-w-[10rem]">
          <SelectValue placeholder="Envio" />
        </SelectTrigger>
        <SelectContent>
          {SEND_FILTERS.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <DatePicker
        value={value.from}
        onChange={(from) => onChange({ ...value, from })}
        placeholder="De"
        className="w-full sm:w-40"
      />
      <DatePicker
        value={value.to}
        onChange={(to) => onChange({ ...value, to })}
        placeholder="Até"
        className="w-full sm:w-40"
      />
    </div>
  );
}
